var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calc-textarea-container"},[_c('div',{staticClass:"textarea",style:({
      maxHeight: _vm.maxHeight + 'px',
      lineHeight: _vm.lineHeight
    }),attrs:{"id":_vm.textareaId},on:{"keyup":function($event){return _vm.saveRangeSub('keyup')},"click":function($event){return _vm.saveRangeSub('click')}}})])}
var staticRenderFns = []

export { render, staticRenderFns }